module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteInformationModel-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelDeleteDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "informationModelDeleteConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "familyName",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.familyName))])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer-content"
    },
    slot: "footer-content"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert$.show),
      expression: "alert$.show"
    }],
    attrs: {
      "closable": false,
      "title": _vm.alert$.message,
      "type": _vm.alert$.type,
      "data-qa": "Dialog-DeleteInformationModel-Alert",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": button.dataQA,
        "disabled": _vm.loading || _vm.errors.any(),
        "loading": _vm.loading,
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f8c30a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformationModelDelete/InformationModelDelete.vue
// module id = 971
// module chunks = 3